(function () {
  const TOP_LINK_SELECTOR = '.js-floating-to-top';
  const BUY_LINK_SELECTOR = '.js-floating-to-buy';
  const PAGE_TOP_SELECTOR = '.section-header, #MainContent';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  const SHOW_AFTER_SCROLL_PX = 500;
  const VISIBLE_CLASS = 'is-visible';
  const HEADER_HEIGHT_VAR = '--header-height';
  const HEADER_HEIGHT_MULTIPLIER = 1;
  const BUY_SCROLL_EXTRA_OFFSET_PX = 10;

  const topLinks = document.querySelectorAll(TOP_LINK_SELECTOR);
  const buyLinks = document.querySelectorAll(BUY_LINK_SELECTOR);
  if (topLinks.length === 0 && buyLinks.length === 0) return;

  let isScrollUpdateScheduled = false;

  topLinks.forEach(function (link) {
    link.addEventListener('click', scrollToPageTop);
  });

  buyLinks.forEach(function (link) {
    link.addEventListener('click', scrollToBuy);
  });

  if (topLinks.length > 0) {
    window.addEventListener('scroll', scheduleTopLinkVisibilityUpdate, { passive: true });
    window.addEventListener('pageshow', updateTopLinkVisibility);
    updateTopLinkVisibility();
  }

  /**
   * スクロール位置の確認を、次の描画タイミングにまとめる。
   * @returns {void}
   */
  function scheduleTopLinkVisibilityUpdate() {
    if (isScrollUpdateScheduled) return;

    isScrollUpdateScheduled = true;
    window.requestAnimationFrame(updateTopLinkVisibility);
  }

  /**
   * 先頭から一定距離スクロールしたときだけ、TOPへ戻るボタンを表示する。
   * @returns {void}
   */
  function updateTopLinkVisibility() {
    isScrollUpdateScheduled = false;
    const isPastThreshold = window.scrollY >= SHOW_AFTER_SCROLL_PX;

    topLinks.forEach(function (link) {
      if (isPastThreshold) {
        link.classList.add(VISIBLE_CLASS);
        link.removeAttribute('aria-hidden');
        return;
      }

      if (document.activeElement === link) {
        link.blur();
      }

      link.classList.remove(VISIBLE_CLASS);
      link.setAttribute('aria-hidden', 'true');
    });
  }

  /**
   * リンク先の位置から、ヘッダー高さと追加余白の分だけ上へスクロールする。
   * @param {MouseEvent} event
   * @returns {void}
   */
  function scrollToBuy(event) {
    const link = event.currentTarget;
    if (!(link instanceof HTMLAnchorElement) || link.hash === '') return;

    const target = document.querySelector(link.hash);
    if (!target) return;

    event.preventDefault();

    const offset = getHeaderHeight() * HEADER_HEIGHT_MULTIPLIER + BUY_SCROLL_EXTRA_OFFSET_PX;
    const targetTop = target.getBoundingClientRect().top + window.scrollY - offset;
    const prefersReducedMotion = window.matchMedia(REDUCED_MOTION_QUERY).matches;

    window.scrollTo({
      top: Math.max(0, targetTop),
      left: 0,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });

    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
    }

    target.focus({ preventScroll: true });
  }

  /**
   * CSS変数 --header-height をpxの数値で返す。
   * @returns {number}
   */
  function getHeaderHeight() {
    const rawValue = getComputedStyle(document.documentElement).getPropertyValue(HEADER_HEIGHT_VAR).trim();
    const headerHeight = parseFloat(rawValue);
    if (Number.isNaN(headerHeight)) return 0;

    return headerHeight;
  }

  /**
   * ページ先頭へスクロールし、フォーカスを先頭へ移す。
   * @param {MouseEvent} event
   * @returns {void}
   */
  function scrollToPageTop(event) {
    event.preventDefault();

    const prefersReducedMotion = window.matchMedia(REDUCED_MOTION_QUERY).matches;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });

    focusPageTop();
  }

  /**
   * 表示位置を動かさずに、ページ先頭の要素へフォーカスを移す。
   * @returns {void}
   */
  function focusPageTop() {
    const pageTop = document.querySelector(PAGE_TOP_SELECTOR);
    if (!pageTop) return;

    if (!pageTop.hasAttribute('tabindex')) {
      pageTop.setAttribute('tabindex', '-1');
    }

    pageTop.focus({ preventScroll: true });
  }
})();
